import React from "react";

import { Text } from "@shopify/polaris";
import type { EditablePurchaseOrderLineItem } from "../../../api_utils/types";

export default function MinOrMinimumOrderQuantityCalculation({
  purchaseOrderLineItem,
}: {
  readonly purchaseOrderLineItem: EditablePurchaseOrderLineItem;
}): React.JSX.Element | string {
  const {
    currently_available,
    recommended_quantity,
    min,
    minimum_order_quantity,
    relevant_purchase_order_quantity,
    pack_size
  } = purchaseOrderLineItem;

let controlling = (<>
    <Text as="p">&nbsp;&nbsp;&nbsp;{min || 0} Minimum needed</Text>
    <Text as="p">- {currently_available} currently available</Text>
    <Text as="p">- {relevant_purchase_order_quantity || 0} ordered</Text>
    <Text as="p">= {recommended_quantity} recommended</Text>
  </>);
  if (minimum_order_quantity && (!min || minimum_order_quantity > min)) {
    controlling = <>
      {min ? <Text as="p">{min} Minimum needed</Text> : null}
      <Text as="p">{minimum_order_quantity || 0} Supplier minimum order quantity</Text>
    </>;
  }

  return (
    <>
      <Text as="strong">Est. calculation</Text>
      {controlling}
      {pack_size ? <><br /><Text as="p">{pack_size} Pack size</Text></> : null}
      <br />
      <Text as="p">Note: Exact recommendations may vary based on other factors.</Text>
    </>
  );
}
